import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { IconCtaColoredBox } from '@ahc-digital/component-library';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { CreateIconCTAColoredBoxModel } from './C32IconCTAColoredBox.service';
import { C32IconCTAColoredBoxProps } from './C32IconCTAColoredBox.types';

const Default = (props?: C32IconCTAColoredBoxProps) => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <IconCtaColoredBox
      {...CreateIconCTAColoredBoxModel(props)}
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
    />
  );
};

export default checkDatasourceForRendering<C32IconCTAColoredBoxProps>(Default);
